<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="lowestLogicalAirfareObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for any flight when the total cost exceeds the benchmark fare by <span
                            class="rule-config-variable" @click="isEdit = !isEdit">
                            <span v-if="lowestLogicalAirfareObj.value.unit == 'dollars'">{{ currencySymbol }}</span>{{ lowestLogicalAirfareObj.value.cost }}
                            <span v-if="lowestLogicalAirfareObj.value.unit == 'percent'">%</span>
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span></p>

                    <div class="box mt-3">
                        <p class="is-italic mb-3">
                            Benchmark fare calculation criteria
                            <span class="rule-config-variable" @click="isEdit = !isEdit">
                                <b-icon icon="pencil" size="is-small"></b-icon>
                            </span>
                        </p>

                        <p v-if="lowestLogicalAirfareObj.value.exceptionAirlines">
                            {{ exceptionString }}<br>
                            {{ convertedAirlineString }}
                        </p>
                        <p v-if="lowestLogicalAirfareObj.value.isRefundable" class="mt-3">Only refundable fares
                        </p>
                    </div>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="lowestLogicalAirfareObj.isActive"
                        v-model="lowestLogicalAirfareObj.isActive" @input="lowestLogicalAirfare" :left-label="true">{{
                            lowestLogicalAirfareObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>

            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <LowestLogicalAirfare :fareOptions="propsData" @lowestLogicalAirfare="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="lowestLogicalAirfareObj.isActive && !isEdit" :ruleObj="lowestLogicalAirfareObj"
            :title="title" @save="updateActions" />
    </div>
</template>
<script>
import LowestLogicalAirfare from "../CommonRules/LowestLogicalAirfare.vue";
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        LowestLogicalAirfare,
        StandardRuleActions
    },
    data() {
        return {
            propsData: {
                amountVal: 5,
                amountType: 'percent',
                airlines: '',
                isRefund: false,
                exceptionVal: ''
            },
            lowestLogicalAirfareObj: this.value ? this.value
                : {
                    name: 'lowestLogicalAirfare',
                    isActive: false,
                    message: 'Trigger when airfare price is not within allowable amount compared with the benchmarked cheapest fare.',
                    type: 'air',
                    value: {
                        exceptionAirlines: "",
                        exception: 'not_in',
                        isRefundable: false,
                        cost: 5,
                        unit: 'percent'
                    }
                },
            isEdit: false,
            emitedValue: null,
            title: 'Cost Compared to Benchmark Fare'

        }

    },
    computed: {
        convertedAirlineString(str) {
            if (this.lowestLogicalAirfareObj.value.exceptionAirlines) {
                let _airlineArr = this.lowestLogicalAirfareObj.value.exceptionAirlines.split(",")
                _airlineArr = _airlineArr.map(this.getAirline);
                let string = _airlineArr.join(', ');
                return string
            } else {
                return null
            }
        },
        exceptionString() {
            let val = this.lowestLogicalAirfareObj.value.exception
            if (val == "in") {
                return 'Only use the following airlines:'
            } else if (val == "not_in") {
                return 'Exclude the following airlines:'
            }
            return ''
        },
        defaultCurrency() {
            return this.$store.getters['travellersAndTrips/getUserCurrencyInfo'];
        },
        currencyCode() {
            return this.defaultCurrency.code;
        },
        currencySymbol(){
            return this.defaultCurrency.symbol;
        }
    },
    methods: {
        lowestLogicalAirfare() {
            if (!this.lowestLogicalAirfareObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        airlineNameConvert(airlineName) {
            let _airlines = Object.entries(this.$store.state.bookTravel.vendors.airlines).map(([key, value]) => ({ key, value }));
            let airline = _airlines.find(({
                value
            }) => value == airlineName);

            if (!airline) return null;

            return airline.key;
        },
        getValue(val) {
            this.emitedValue = val;
        },
        getAirline(val) {
            return this.$helpers.airlineName(val)
        },
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue) {
                if (this.emitedValue.exceptionAirlines) {
                    let _arr = this.emitedValue.exceptionAirlines
                    _arr = _arr.map(this.airlineNameConvert)
                    this.emitedValue.exceptionAirlines = _arr.join()
                }
                this.lowestLogicalAirfareObj.value = this.emitedValue;
            }
            this.buildMessage();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.lowestLogicalAirfareObj.useCustomActions = false;
            delete this.lowestLogicalAirfareObj.visibility;
            delete this.lowestLogicalAirfareObj.approvalLevel;
            delete this.lowestLogicalAirfareObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into lowestLogicalAirfareObj
            this.lowestLogicalAirfareObj = { ...this.lowestLogicalAirfareObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
        buildMessage() {
            let _cost = this.lowestLogicalAirfareObj.value.cost;
            let _unit = this.lowestLogicalAirfareObj.value.unit;

            let costDisplay;
            if (_unit == 'dollars') {
                // For dollars, use formatPrice and omit unit from message
                costDisplay = this.currencySymbol + _cost;
            } else {
                // For other units (like percent), include unit after cost
                costDisplay = _cost + _unit;
            }

            this.lowestLogicalAirfareObj.message =
                `Trigger when airfare price is more than ${costDisplay} compared with the benchmarked cheapest fare.`;

        },
        emitRuleObj() {
            this.$emit("lowestLogicalAirfare", this.lowestLogicalAirfareObj);
        }
    },
    mounted() {
        this.emitRuleObj();
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const airfareProps = this.value;
                    this.lowestLogicalAirfareObj = airfareProps
                    this.propsData.amountVal = airfareProps.value.cost;
                    this.propsData.amountType = airfareProps.value.unit;
                    this.propsData.airlines = airfareProps.value.exceptionAirlines;
                    this.propsData.exceptionVal = airfareProps.value.exception;
                    this.propsData.isRefund = airfareProps.value.isRefundable;
                }
                this.buildMessage();
                this.lowestLogicalAirfareObj.type = "air";
                this.emitRuleObj();
            },
            deep: true,
        },
    }
}
</script>